import styled, { css } from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  margin-top: 1rem;

  @media (min-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    height: calc(100vh - 190px);
    overflow-y: auto;
  }
`;

export const Card = styled.button`
  border-radius: 8px;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  background-color: transparent;
  border: 0;
  text-align: left;
  display: flex;
  flex-direction: column;

  & + button {
    margin-top: 1rem;
  }

  @media (min-width: 768px) {
    width: 340px;

    & + button {
      margin-top: 0rem;
    }
  }
`;

export const BackgroundImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  object-position: 20% 20%;
`;

export const ContentCard = styled.div`
  ${({ theme }) => css`
    padding: 0.75rem 1rem 1rem;
    display: flex;
    flex-direction: column;
    flex: 1;

    > h4 {
      font-size: 1.125rem;
      color: ${theme.colors.black};
      font-weight: normal;
      margin: 0;
      height: 60px;
      line-height: 1.25;
    }

    > p {
      margin: 0;
      padding-top: 0.5rem;
      color: ${theme.colors.black};
      opacity: 0.5;
      flex: 1;
    }

    > span {
      display: block;
      padding-top: 0.5rem;
      color: ${theme.colors.black};
      opacity: 0.25;
      height: 30px;
    }

    @media (min-width: 768px) {
      height: 50px;
    }
  `}
`;
